import React, { createContext, useContext, useEffect, useState } from "react";
import i18n from "../../i18n";

const LanguageRegionContext = createContext();
const regionForLanguage = (language) => language.code === 'de'
  ? { nameReg: 'Österreich', code: 'at' }
  : { ...language, nameReg: language.nameReg || language.nameLang };

export const LanguageRegionProvider = ({ children }) => {
  const [lang, setLang] = useState({ nameLang: "Русский", code: "ru" });
  const [region, setRegion] = useState({ nameReg: "Россия", code: "ru" });

  useEffect(() => {
    const savedLang = localStorage.getItem("language");
    let activeLang;
    if (savedLang) {
      const parsedLang = JSON.parse(savedLang);
      activeLang = parsedLang;
      setLang(parsedLang);
      i18n.changeLanguage(parsedLang.code); 
    } else {
      const browserLang = navigator.language || navigator.userLanguage;
      const defaultLang = browserLang.toLowerCase().startsWith("ru")
        ? { nameLang: "Русский", code: "ru" }
        : { nameLang: "English", nameReg: "Europe", code: "en" };
      activeLang = defaultLang;
      setLang(defaultLang);
      i18n.changeLanguage(defaultLang.code);
    }

    const savedRegion = localStorage.getItem("region");
    if (savedRegion) {
      const parsedRegion = JSON.parse(savedRegion);
      if (parsedRegion.code === "ru" && activeLang.code !== "ru") {
        const syncedRegion = regionForLanguage(activeLang);
        setRegion(syncedRegion);
        localStorage.setItem("region", JSON.stringify(syncedRegion));
      } else {
        setRegion(parsedRegion);
      }
    } else if (activeLang.code !== "ru") {
      const defaultRegion = regionForLanguage(activeLang);
      setRegion(defaultRegion);
      localStorage.setItem("region", JSON.stringify(defaultRegion));
    }
  }, []);

  const updateLang = (newLang) => {
    if (newLang.code !== lang.code) {
      setLang(newLang);
      localStorage.setItem('language', JSON.stringify(newLang));
      i18n.changeLanguage(newLang.code);
    }
    const syncedRegion = regionForLanguage(newLang);
    if (region.code !== syncedRegion.code) {
      setRegion(syncedRegion);
      localStorage.setItem("region", JSON.stringify(syncedRegion));
    }
  };

  const updateRegion = (newRegion) => {
    if (newRegion.code !== region.code) {
      setRegion(newRegion);
      localStorage.setItem("region", JSON.stringify(newRegion));
    }
  };

  const clearStorage = () => {
    localStorage.removeItem('language');
    localStorage.removeItem('region');
    const defaultLang = { nameLang: 'Русский', code: 'ru' };
    setLang(defaultLang);
    setRegion({ nameReg: 'Россия', code: 'ru' });
    i18n.changeLanguage(defaultLang.code);
  };

  return (
    <LanguageRegionContext.Provider
      value={{ lang, region, updateLang, updateRegion, clearStorage }}
    >
      {children}
    </LanguageRegionContext.Provider>
  );
};

export const useLanguageRegion = () => useContext(LanguageRegionContext);
